import { render, staticRenderFns } from "./PdpComfortScale.vue?vue&type=template&id=7247dbed&scoped=true&"
import script from "./PdpComfortScale.vue?vue&type=script&lang=js&"
export * from "./PdpComfortScale.vue?vue&type=script&lang=js&"
import style0 from "./PdpComfortScale.vue?vue&type=style&index=0&id=7247dbed&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7247dbed",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIconScale: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconScale.vue').default})
